export const TEST_TYPES_REQUEST = "testTypesConstants/TEST_TYPES_REQUEST";
export const TEST_TYPES_SUCCESS = "testTypesConstants/TEST_TYPES_SUCCESS";
export const TEST_TYPES_FAIL = "testTypesConstants/TEST_TYPES_FAIL";
